import React from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core"
import LoadingButton from "../../../LoadingButton"
import { openSnackBar } from "../../../../actions/snack-bar"
import { toggleCreateSoloDialog } from "../../../../actions/billingDialogs"
import { useState } from "react"
import { createSoloCall } from "../../../../actions/solos"

import useStyles from "./styles"

const CreateSoloDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const open = useSelector(state => state.billingDialogs.createSoloDialogOpen)
  const data = useSelector(state => state.billingDialogs.data)

  const type = data && data.type
  const history = data && data.history
  const creator_id = data && data.creator_id
  const company_id = data && data.company_id

  const handleClose = () => {
    dispatch(toggleCreateSoloDialog(false))
  }

  const createSolo = type => {
    let data = { creator_id: creator_id, company_id: company_id }
    setLoading(true)
    dispatch(createSoloCall(type, data))
      .then(res => {
        let id = res[`${type}_id`]
        history.push(`billing/solo-${type.toLowerCase()}/${id}`)
        setLoading(false)
        handleClose()
      })
      .catch(err => {
        dispatch(openSnackBar({ message: `Error creating solo ${type}` }))
        setLoading(false)
      })
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">
          Create Solo {type && type.charAt(0).toUpperCase() + type.slice(1)}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h5">
          Are you sure you want to create an {type}?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <LoadingButton
          size={window.innerWidth > 600 ? "medium" : "small"}
          variant="outlined"
          color="primary"
          className={classes.button}
          onClick={handleClose}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          size={window.innerWidth > 600 ? "medium" : "small"}
          variant="contained"
          color="primary"
          working={loading}
          disabled={loading}
          className={classes.button}
          onClick={() => createSolo(type)}
        >
          Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default CreateSoloDialog
